import { ILopUpdateCTDTRequest } from "../../../model/request/category/ILopUpdateCTDTRequest";
import { IStuLop } from "../../../model/respone/category/IStuLop";
import { IStuLopViewModel } from "../../../model/respone/category/IStuLopViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eStuLopNamHocActionsObj = {
  CHANGE_NAM_HOC: "",
  LOAD_START: "",
  LOAD_SUCCESS: {} as IStuLopViewModel[],
  LOAD_ERRR: "",
  REFRESH: undefined,

  UPDATE_CTDT_START: {} as ILopUpdateCTDTRequest,
  UPDATE_CTDT_SUCCESS: {} as IStuLop[],
  UPDATE_CTDT_ERRR: "",

};
export const eStuLopNamHocActionIds = generateActionTypeIds(
  eStuLopNamHocActionsObj,
  "LOP_NAM_HOC"
);
export type IStuLopNamHocActionTypes = IGenericActionType<
  typeof eStuLopNamHocActionsObj,
  "LOP_NAM_HOC"
>;
